import { ApplicationsAction } from "./applications";
import { DirectoryAction } from "./directory";
import { EnvironmentsAction } from "./environments";
import { CategoriesAction } from "./category";
import { SystemTypesAction } from "./systemtypes";
import { EmployeesAction } from "./employees";
import { FlagsAction } from "./flags";
import { InfrastructureApplicationsAction } from "./infrastructure-applications";
import { RolesAction } from "./roles";
import { SessionAction } from "./session";
import { SettingsAction } from "./settings";
import { UserIDAction } from "./user_ids";
import { UserSettingsAction } from "./user_settings";
import { UserDelegatesAction } from "./user_delegates";
import { ApproverDistroActions } from "./approverdistro";
import { VIPsAction } from "./vips";
import { LandingZoneRolesAction } from "./landing-zone-roles";

export * from "./approverdistro";
export * from "./applications";
export * from "./directory";
export * from "./environments";
export * from "./systemtypes";
export * from "./employees";
export * from "./category";
export * from "./flags";
export * from "./infrastructure-applications";
export * from "./network";
export * from "./roles";
export * from "./settings";
export * from "./user";
export * from "./user_ids";
export * from "./user_settings";
export * from "./user_delegates";
export * from "./feedback";
export * from "./vips";
export * from "./landing-zone-roles";

export enum ActionType {
  GET_APPROVERDISTRO_REQUEST = "GET_APPROVERDISTRO_REQUEST",
  GET_APPROVALDISTRO_SUCCESS = "GET_APPROVALDISTRO_SUCCESS",
  GET_APPROVERDISTRO_FAILURE = "GET_APPROVERDISTRO_FAILURE",
  GET_APPLICATIONS_REQUEST = "GET_APPLICATIONS_REQUEST",
  GET_APPLICATIONS_SUCCESS = "GET_APPLICATIONS_SUCCESS",
  GET_APPLICATIONS_FAILURE = "GET_APPLICATIONS_FAILURE",
  GET_ENVIRONMENTS_REQUEST = "GET_ENVIRONMENTS_REQUEST",
  GET_ENVIRONMENTS_SUCCESS = "GET_ENVIRONMENTS_SUCCESS",
  GET_ENVIRONMENTS_FAILURE = "GET_ENVIRONMENTS_FAILURE",
  GET_CATEGORIES_REQUEST = "GET_CATEGORIES_REQUEST",
  GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS",
  GET_CATEGORIES_FAILURE = "GET_CATEGORIES_FAILURE",
  GET_SYSTEMTYPE_REQUEST = "GET_SYSTEMTYPE_REQUEST",
  GET_SYSTEMTYPE_SUCCESS = "GET_SYSTEMTYPE_SUCCESS",
  GET_SYSTEMTYPE_FAILURE = "GET_SYSTEMTYPE_FAILURE",
  GET_EMPLOYEES_REQUEST = "GET_EMPLOYEES_REQUEST",
  GET_EMPLOYEES_SUCCESS = "GET_EMPLOYEES_SUCCESS",
  GET_EMPLOYEES_FAILURE = "GET_EMPLOYEES_FAILURE",
  GET_ROLES_REQUEST = "GET_ROLES_REQUEST",
  GET_ROLES_SUCCESS = "GET_ROLES_SUCCESS",
  GET_ROLES_FAILURE = "GET_ROLES_FAILURE",
  GET_INFRASTRUCTURE_APPLICATIONS_REQUEST = "GET_INFRASTRUCTURE_APPLICATIONS_REQUEST",
  GET_INFRASTRUCTURE_APPLICATIONS_SUCCESS = "GET_INFRASTRUCTURE_APPLICATIONS_SUCCESS",
  GET_INFRASTRUCTURE_APPLICATIONS_FAILURE = "GET_INFRASTRUCTURE_APPLICATIONS_FAILURE",
  TOGGLE_FLAG = "TOGGLE_FLAG",
  GET_USER_ID_REQUEST = "GET_USER_ID_REQUEST",
  GET_USER_ID_SUCCESS = "GET_USER_ID_SUCCESS",
  GET_USER_ID_FAILURE = "GET_USER_ID_FAILURE",
  GET_DIRECTORY_REQUEST = "GET_DIRECTORY_REQUEST",
  GET_DIRECTORY_SUCCESS = "GET_DIRECTORY_SUCCESS",
  GET_DIRECTORY_FAILURE = "GET_DIRECTORY_FAILURE",
  GET_SETTINGS_REQUEST = "GET_SETTINGS_REQUEST",
  GET_SETTINGS_SUCCESS = "GET_SETTINGS_SUCCESS",
  GET_SETTINGS_FAILURE = "GET_SETTINGS_FAILURE",
  GET_SESSION_SUCCESS = "GET_SESSION_SUCCESS",
  GET_SESSION_FAILURE = "GET_SESSION_FAILURE",
  GET_USER_SETTINGS_REQUEST = "GET_USER_SETTINGS_REQUEST",
  GET_USER_SETTINGS_SUCCESS = "GET_USER_SETTINGS_SUCCESS",
  GET_USER_SETTINGS_FAILURE = "GET_USER_SETTINGS_FAILURE",
  GET_VIPS_REQUEST = "GET_VIPS_REQUEST",
  GET_VIPS_SUCCESS = "GET_VIPS_SUCCESS",
  GET_VIPS_FAILURE = "GET_VIPS_FAILURE",
  UPDATE_USER_SETTINGS_REQUEST = "UPDATE_USER_SETTINGS_REQUEST",
  UPDATE_USER_SETTINGS_SUCCESS = "UPDATE_USER_SETTINGS_SUCCESS",
  UPDATE_USER_SETTINGS_FAILURE = "UPDATE_USER_SETTINGS_FAILURE",
  DELETE_USER_DELEGATE_REQUEST = "DELETE_USER_DELEGATE_REQUEST",
  DELETE_USER_DELEGATE_SUCCESS = "DELETE_USER_DELEGATE_SUCCESS",
  DELETE_USER_DELEGATE_FAILURE = "DELETE_USER_DELEGATE_FAILURE",
  GET_USER_DELEGATES_REQUEST = "GET_USER_DELEGATES_REQUEST",
  GET_USER_DELEGATES_SUCCESS = "GET_USER_DELEGATES_SUCCESS",
  GET_USER_DELEGATES_FAILURE = "GET_USER_DELEGATES_FAILURE",
  CREATE_USER_DELEGATE_REQUEST = "CREATE_USER_DELEGATE_REQUEST",
  CREATE_USER_DELEGATE_SUCCESS = "CREATE_USER_DELEGATE_SUCCESS",
  CREATE_USER_DELEGATE_FAILURE = "CREATE_USER_DELEGATE_FAILURE",
  UPDATE_USER_DELEGATE_REQUEST = "UPDATE_USER_DELEGATE_REQUEST",
  UPDATE_USER_DELEGATE_SUCCESS = "UPDATE_USER_DELEGATE_SUCCESS",
  UPDATE_USER_DELEGATE_FAILURE = "UPDATE_USER_DELEGATE_FAILURE",
  GET_LANDING_ZONE_ROLES_REQUEST = "GET_LANDING_ZONE_ROLES_REQUEST",
  GET_LANDING_ZONE_ROLES_SUCCESS = "GET_LANDING_ZONE_ROLES_SUCCESS",
  GET_LANDING_ZONE_ROLES_FAILURE = "GET_LANDING_ZONE_ROLES_FAILURE",
}

export type Action =
  | ApplicationsAction
  | EnvironmentsAction
  | SystemTypesAction
  | RolesAction
  | InfrastructureApplicationsAction
  | FlagsAction
  | UserIDAction
  | DirectoryAction
  | SettingsAction
  | SessionAction
  | UserSettingsAction
  | UserDelegatesAction
  | CategoriesAction
  | EmployeesAction
  | VIPsAction
  | LandingZoneRolesAction;
